import React from 'react';

interface ThreadsIconProps {
  size?: number;
  className?: string;
}

const ThreadsIcon: React.FC<ThreadsIconProps> = ({ size = 20, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.5 12.5v-.007c0-3.086.85-5.94 2.495-8.491C5.845 1.205 8.598.024 12.179 0h.014c3.581.024 6.334 1.205 8.184 3.509C21.65 5.56 22.5 8.414 22.5 11.5v.007c0 3.086-.85 5.94-2.495 8.491C18.155 22.795 15.402 23.976 11.821 24h-.007zm.014-22c-2.794.019-4.976.904-6.487 2.632C4.24 6.287 3.5 8.6 3.5 11.5v.007c0 2.9.74 5.213 2.213 6.868 1.511 1.728 3.693 2.613 6.487 2.632h.007c2.794-.019 4.976-.904 6.487-2.632C19.76 16.713 20.5 14.4 20.5 11.5v-.007c0-2.9-.74-5.213-2.213-6.868C16.776 2.897 14.594 2.012 11.8 1.993h-.014z"/>
      <path d="M17.74 10.193c-.133-1.013-.24-1.847-.24-2.347 0-.5.107-1.334.24-2.347.133-1.013.24-1.847.24-2.347 0-.5-.107-1.334-.24-2.347C17.607 0.292 17.5 0 17.5 0s-.107.292-.24.805c-.133 1.013-.24 1.847-.24 2.347 0 .5.107 1.334.24 2.347.133 1.013.24 1.847.24 2.347 0 .5-.107 1.334-.24 2.347-.133 1.013-.24 1.847-.24 2.347 0 .5.107 1.334.24 2.347.133 1.013.24 1.847.24 2.347 0 .5-.107 1.334-.24 2.347C17.393 23.708 17.5 24 17.5 24s.107-.292.24-.805c.133-1.013.24-1.847.24-2.347 0-.5-.107-1.334-.24-2.347-.133-1.013-.24-1.847-.24-2.347 0-.5.107-1.334.24-2.347.133-1.013.24-1.847.24-2.347 0-.5-.107-1.334-.24-2.347z"/>
      <path d="M15.426 12c0 1.052-.853 1.905-1.905 1.905s-1.905-.853-1.905-1.905.853-1.905 1.905-1.905S15.426 10.948 15.426 12z"/>
      <path d="M12 8.571c-1.893 0-3.429 1.536-3.429 3.429S10.107 15.429 12 15.429s3.429-1.536 3.429-3.429S13.893 8.571 12 8.571zm0 5.714c-1.262 0-2.286-1.024-2.286-2.286S10.738 9.714 12 9.714s2.286 1.024 2.286 2.286S13.262 14.286 12 14.286z"/>
    </svg>
  );
};

export default ThreadsIcon;
